import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetParamsWithNestedParam } from '../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { Submotive4ListActions } from './actions';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    Param,
    ParamWithNestedParent,
} from '../../../../../shared/types/param';
import { TableTooltip } from '../../../../components/general/table';

export const useSubmotive4List = (filters?: ParamWithNestedParent) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Param[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<
        ParamWithNestedParent | object
    >({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Param>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <Submotive4ListActions id={row.row.id || ''} />
            ),
        });
    }

    columns.push(
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.5,
        },
        {
            field: 'nestedParent4',
            headerName: 'Tipo PQR',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        (
                            (
                                (
                                    (
                                        (row.row.parent as ISelect)
                                            ?.parent as ISelect
                                    )?.parent as ISelect
                                )?.parent as ISelect
                            )?.parent as ISelect
                        )?.name || ''
                    }
                />
            ),
        },
        {
            field: 'nestedParent3',
            headerName: 'Motivo',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        (
                            (
                                ((row.row.parent as ISelect)?.parent as ISelect)
                                    ?.parent as ISelect
                            )?.parent as ISelect
                        )?.name || ''
                    }
                />
            ),
        },
        {
            field: 'nestedParent2',
            headerName: 'Submotivo 1',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        (
                            ((row.row.parent as ISelect)?.parent as ISelect)
                                ?.parent as ISelect
                        )?.name || ''
                    }
                />
            ),
        },
        {
            field: 'nestedParent',
            headerName: 'Submotivo 2',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        ((row.row.parent as ISelect)?.parent as ISelect)
                            ?.name || ''
                    }
                />
            ),
        },
        {
            field: 'parent',
            headerName: 'Submotivo 3',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip value={(row.row.parent as ISelect)?.name || ''} />
            ),
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 80,
            flex: 0.4,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <>{row.row.active ? 'Si' : 'No'}</>,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.6,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <DateTooltip date={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        let name: string | undefined;
        let active: boolean | undefined;
        let parent: string | undefined;
        let nestedParent: string | undefined;
        let nestedParent2: string | undefined;
        let nestedParent3: string | undefined;
        let nestedParent4: string | undefined;

        if (
            finalFilters &&
            'name' in finalFilters &&
            'active' in finalFilters &&
            'parent' in finalFilters &&
            'nestedParent' in finalFilters &&
            'nestedParent2' in finalFilters &&
            'nestedParent3' in finalFilters &&
            'nestedParent4' in finalFilters
        ) {
            ({
                name,
                active,
                parent,
                nestedParent,
                nestedParent2,
                nestedParent3,
                nestedParent4,
            } = finalFilters as {
                name?: string;
                active?: boolean;
                parent?: string;
                nestedParent?: string;
                nestedParent2?: string;
                nestedParent3?: string;
                nestedParent4?: string;
            });
        }

        asyncGetParamsWithNestedParam(
            ParamEnum.PQR_SUBMOTIVE4,
            parent,
            nestedParent,
            name,
            '',
            active,
            page,
            pageSize,
            5,
            nestedParent2,
            nestedParent3,
            nestedParent4
        )
            .then((res: any) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
